// ===== components/Navbar/Navbar.js =====
import React, { useState } from 'react';
import './Navbar.css';

const Navbar = ({ currentPage, setCurrentPage, isLoggedIn, onLogout, user }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavClick = (page) => {
    setCurrentPage(page);
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    // Use the onLogout prop passed from App.js which contains the proper logout logic
    if (onLogout) {
      onLogout();
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        {/* Logo */}
        <div className="nav-logo" onClick={() => handleNavClick('home')}>
          <img 
            src="/images/logo.jpg" 
            alt="Transcontinental Network Logo" 
            className="nav-logo-image"
          />
          <div className="nav-logo-text">
            <span className="logo-main">TRANSCONTINENTAL</span>
            <span className="logo-sub">NETWORK</span>
          </div>
        </div>

        {/* Desktop Menu */}
        <ul className="nav-menu">
          <li className="nav-item">
            <button 
              className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
              onClick={() => handleNavClick('home')}
            >
              Home
            </button>
          </li>
          <li className="nav-item">
            <button 
              className={`nav-link ${currentPage === 'services' ? 'active' : ''}`}
              onClick={() => handleNavClick('services')}
            >
              Services
            </button>
          </li>
          <li className="nav-item">
            <button 
              className={`nav-link ${currentPage === 'web-development' ? 'active' : ''}`}
              onClick={() => handleNavClick('web-development')}
            >
              Web &amp; Hosting
            </button>
          </li>
          <li className="nav-item">
            <button 
              className={`nav-link ${currentPage === 'products' ? 'active' : ''}`}
              onClick={() => handleNavClick('products')}
            >
              Products
            </button>
          </li>
          <li className="nav-item">
            <button 
              className={`nav-link ${currentPage === 'about' ? 'active' : ''}`}
              onClick={() => handleNavClick('about')}
            >
              About
            </button>
          </li>
          <li className="nav-item">
            <button 
              className={`nav-link ${currentPage === 'blog' ? 'active' : ''}`}
              onClick={() => handleNavClick('blog')}
            >
              Blog
            </button>
          </li>
          <li className="nav-item">
            <button 
              className={`nav-link ${currentPage === 'contact' ? 'active' : ''}`}
              onClick={() => handleNavClick('contact')}
            >
              Contact
            </button>
          </li>
          {isLoggedIn && (
            <>
              <li className="nav-item">
                <button 
                  className={`nav-link ${currentPage === 'cart' ? 'active' : ''}`}
                  onClick={() => handleNavClick('cart')}
                >
                  Cart
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${currentPage === 'my-orders' ? 'active' : ''}`}
                  onClick={() => handleNavClick('my-orders')}
                >
                  My Orders
                </button>
              </li>
            </>
          )}
        </ul>

        {/* Auth Buttons */}
        <div className="nav-auth">
          {isLoggedIn ? (
            <div className="user-menu">
              <span className="user-greeting">
               {user && user.name ? ` ${user.name}` : ''}!
              </span>
              <button className="btn btn-secondary" onClick={handleLogout}>
                LOGOUT
              </button>
            </div>
          ) : (
            <button 
              className="btn btn-primary"
              onClick={() => handleNavClick('login')}
            >
              Login
            </button>
          )}
        </div>

        {/* Mobile Menu Button */}
        <div className={`nav-toggle ${isMenuOpen ? 'active' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
        <button 
          className={`mobile-nav-link ${currentPage === 'home' ? 'active' : ''}`}
          onClick={() => handleNavClick('home')}
        >
          Home
        </button>
        <button 
          className={`mobile-nav-link ${currentPage === 'services' ? 'active' : ''}`}
          onClick={() => handleNavClick('services')}
        >
          Services
        </button>
        <button 
          className={`mobile-nav-link ${currentPage === 'web-development' ? 'active' : ''}`}
          onClick={() => handleNavClick('web-development')}
        >
          Web &amp; Hosting
        </button>
        <button 
          className={`mobile-nav-link ${currentPage === 'products' ? 'active' : ''}`}
          onClick={() => handleNavClick('products')}
        >
          Products
        </button>
        <button 
          className={`mobile-nav-link ${currentPage === 'about' ? 'active' : ''}`}
          onClick={() => handleNavClick('about')}
        >
          About
        </button>
        <button 
          className={`mobile-nav-link ${currentPage === 'blog' ? 'active' : ''}`}
          onClick={() => handleNavClick('blog')}
        >
          Blog
        </button>
        <button 
          className={`mobile-nav-link ${currentPage === 'contact' ? 'active' : ''}`}
          onClick={() => handleNavClick('contact')}
        >
          Contact
        </button>
        
        {isLoggedIn && (
          <>
            <div className="mobile-menu-divider"></div>
            <button 
              className={`mobile-nav-link ${currentPage === 'cart' ? 'active' : ''}`}
              onClick={() => handleNavClick('cart')}
            >
              Cart
            </button>
            <button 
              className={`mobile-nav-link ${currentPage === 'my-orders' ? 'active' : ''}`}
              onClick={() => handleNavClick('my-orders')}
            >
              My Orders
            </button>
          </>
        )}
        
        <div className="mobile-auth">
          {isLoggedIn ? (
            <button className="btn btn-secondary" onClick={handleLogout}>
              LOGOUT
            </button>
          ) : (
            <button 
              className="btn btn-primary"
              onClick={() => handleNavClick('login')}
            >
              Login
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;